export enum TrackingModes {
  AUTOMATED = 'automated',
  MANUAL = 'manual',
}
